import React from 'react';

function CBCForm() {
  return (
    <div>
      <h2>CBCForm</h2>
    </div>
  );
}

export default CBCForm;
